import React from 'react';
import { View } from 'react-native';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Text from './Text';
import { rem } from './values';
const InputFeedback = ({ children, type = 'info', title, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const color = type === 'info' ? colors.text.secondary : colors.status.negative;
    return (<View style={styles.infoView}>
      <View style={[styles.line, type === 'error' && styles.errorLine]}/>
      <View style={styles.flex}>
        {!!title && (<Text Text-14 color={color}>
            {title}
          </Text>)}
        {children ? (<Text TextThin-14 color={color}>
            {children}
          </Text>) : null}
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    flex: {
        flex: 1,
    },
    line: {
        width: rem(2),
        borderRadius: rem(2),
        marginRight: rem(16),
        backgroundColor: colors.elements.brand,
    },
    errorLine: {
        backgroundColor: colors.status.negative,
    },
    infoView: {
        flexDirection: 'row',
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
}));
export default InputFeedback;
